import { DocumentDto } from '../../../../projects/tilled-api-client/src/model/documentDto';
export function isAchReturnDocumentHelper(subtype: DocumentDto.SubtypeEnum): boolean {
  return [
    DocumentDto.SubtypeEnum.ADMIN_RETURN,
    DocumentDto.SubtypeEnum.INSUFFICIENT_FUNDS_RETURN,
    DocumentDto.SubtypeEnum.UNAUTHORIZED_RETURN,
  ].includes(subtype);
}
